/**
 * ComOS Federation logo for the design-system nav/footer. (CO 069)
 * Two drawings, one per theme: the `dark` class on <html> picks which shows.
 */
export function Brand() {
  return (
    <>
      <img
        src="/comos-federation-logo-compact.svg"
        alt="ComOS Federation"
        className="h-10 w-auto max-w-none shrink-0 dark:hidden"
      />
      <img
        src="/comos-federation-logo-compact-dark.svg"
        alt="ComOS Federation"
        className="hidden h-10 w-auto max-w-none shrink-0 dark:block"
      />
    </>
  );
}
